import React, { Component } from 'react';
import { Popup, View } from 'framework7-react';
import './CodeAuthenticationPopup.css';
import CodeAuthenticationPage from '../../pages/codeAuthenticationPage/CodeAuthenticationPage';
import FontIcon from '../../fontIcon/FontIcon';
import UserSignaturePage from "../../pages/userSignaturePage/UserSignaturePage";
import mainAPI from "../../../api/MainAPI";

window.showBiometricCode = () => {
	window.popupController.show(CodeAuthenticationPopup, {})
};

export default class CodeAuthenticationPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: this.props.opened,
			hasSignature: Boolean(localStorage.hasSignature) === true? true: null,
		};
	}
	componentDidMount = async ()=> {
		const response= await mainAPI.user_signature.current();
		if(response){
			this.setState({hasSignature:true});
			localStorage.hasUserSignature = 'true'
		}else{
			this.setState({hasSignature:false})
			delete localStorage.hasUserSignature;
		}
	}

	componentWillReceiveProps = (nextProps) => {
		this.setState({ opened: nextProps.opened });
	};

	close = () => {
		this.setState({ opened: false });
		window.popupController.hide(CodeAuthenticationPopup);
	};

	render() {
		return (
			<Popup
				tabletFullscreen
				opened={this.state.opened}
				className="g-code-authentication-popup"
				id="CodeAuthenticationPopup"
			>
				<FontIcon onClick={this.close} name="icon-close" color="white" />
				{this.state.hasSignature !== null && <View stackPages name={'code_auth'}>
					{this.state.hasSignature === true && <CodeAuthenticationPage onClose={this.close} secondsUntilClosed={this.state.secondsUntilClosed} />}
					{this.state.hasSignature === false && <UserSignaturePage onClose={this.close}/>}
				</View>}
			</Popup>
		);
	}
}
